import {useEffect, useRef} from "react";

import {
    hashEmailForAmplitudeUserId,
    hashPhoneForAmplitudeUserProperty,
    setAmplitudeUserId,
    setAmplitudeUserProperties,
    waitForAmplitudeInitialization
} from "@pg-mono/amplitude";

import {useGetUserProfileQuery} from "../../user/api/user_api";
import {getProfilePictureAuthKind, getProfilePictureCaptured} from "../../user/utils/profile_picture";

type AmplitudeSyncedUserProperties = {
    email: string;
    phone_verified: boolean;
    phone_number?: string;
    profile_picture_captured?: boolean | null;
};

export const AmplitudeUserTracker = () => {
    const {data: userProfile, isFetching} = useGetUserProfileQuery();
    const prevUserIdRef = useRef<string | null>(null);
    const lastIdentifyKeyRef = useRef<string | null>(null);

    const email = userProfile?.email;
    const phone = userProfile?.phone;
    const phoneVerified = userProfile?.phone_verified;
    const picture = userProfile?.picture;

    useEffect(() => {
        let cancelled = false;

        const syncAmplitudeUser = async () => {
            await waitForAmplitudeInitialization();

            if (cancelled) return;

            if (email) {
                const hashedEmail = hashEmailForAmplitudeUserId(email);
                const hashedPhone = phone ? hashPhoneForAmplitudeUserProperty(phone) : null;
                const authKind = getProfilePictureAuthKind();
                const profilePictureCaptured = getProfilePictureCaptured({picture}, authKind);
                const identifyKey = `${hashedEmail}|${hashedPhone ?? ""}|${Boolean(phoneVerified)}|${authKind}|${String(profilePictureCaptured)}`;

                if (lastIdentifyKeyRef.current === identifyKey) return;

                const shouldSendProfilePictureCaptured = authKind !== null || profilePictureCaptured === true;
                const userProperties: AmplitudeSyncedUserProperties = {
                    email: hashedEmail,
                    phone_verified: Boolean(phoneVerified),
                    ...(hashedPhone ? {phone_number: hashedPhone} : {}),
                    ...(shouldSendProfilePictureCaptured ? {profile_picture_captured: profilePictureCaptured} : {})
                };

                // Handle edge case: email changed — send previous ID as property before updating User ID
                if (prevUserIdRef.current && prevUserIdRef.current !== hashedEmail) {
                    setAmplitudeUserProperties({previous_hashed_email: prevUserIdRef.current});
                }

                setAmplitudeUserId(hashedEmail);

                setAmplitudeUserProperties(userProperties);

                prevUserIdRef.current = hashedEmail;
                lastIdentifyKeyRef.current = identifyKey;
            } else if (prevUserIdRef.current && !isFetching) {
                // Logout or profile fetch error — reset UserId
                setAmplitudeUserId(undefined);
                prevUserIdRef.current = null;
                lastIdentifyKeyRef.current = null;
            }
        };

        void syncAmplitudeUser();

        return () => {
            cancelled = true;
        };
    }, [email, phone, phoneVerified, picture, isFetching]);

    return null;
};
import {useEffect, useRef} from "react";

import {
    hashEmailForAmplitudeUserId,
    hashPhoneForAmplitudeUserProperty,
    setAmplitudeUserId,
    setAmplitudeUserProperties,
    waitForAmplitudeInitialization
} from "@pg-mono/amplitude";

import {useGetUserProfileQuery} from "../../user/api/user_api";
import {getProfilePictureAuthKind, getProfilePictureCaptured} from "../../user/utils/profile_picture";

type AmplitudeSyncedUserProperties = {
    email: string;
    phone_verified: boolean;
    phone_number?: string;
    profile_picture_captured?: boolean | null;
};

export const AmplitudeUserTracker = () => {
    const {data: userProfile, isFetching} = useGetUserProfileQuery();
    const prevUserIdRef = useRef<string | null>(null);
    const lastIdentifyKeyRef = useRef<string | null>(null);

    const email = userProfile?.email;
    const phone = userProfile?.phone;
    const phoneVerified = userProfile?.phone_verified;
    const picture = userProfile?.picture;

    useEffect(() => {
        let cancelled = false;

        const syncAmplitudeUser = async () => {
            await waitForAmplitudeInitialization();

            if (cancelled) return;

            if (email) {
                const hashedEmail = hashEmailForAmplitudeUserId(email);
                const hashedPhone = phone ? hashPhoneForAmplitudeUserProperty(phone) : null;
                const authKind = getProfilePictureAuthKind();
                const profilePictureCaptured = getProfilePictureCaptured({picture}, authKind);
                const identifyKey = `${hashedEmail}|${hashedPhone ?? ""}|${Boolean(phoneVerified)}|${authKind}|${String(profilePictureCaptured)}`;

                if (lastIdentifyKeyRef.current === identifyKey) return;

                const shouldSendProfilePictureCaptured = authKind !== null || profilePictureCaptured === true;
                const userProperties: AmplitudeSyncedUserProperties = {
                    email: hashedEmail,
                    phone_verified: Boolean(phoneVerified),
                    ...(hashedPhone ? {phone_number: hashedPhone} : {}),
                    ...(shouldSendProfilePictureCaptured ? {profile_picture_captured: profilePictureCaptured} : {})
                };

                // Handle edge case: email changed — send previous ID as property before updating User ID
                if (prevUserIdRef.current && prevUserIdRef.current !== hashedEmail) {
                    setAmplitudeUserProperties({previous_hashed_email: prevUserIdRef.current});
                }

                setAmplitudeUserId(hashedEmail);

                setAmplitudeUserProperties(userProperties);

                prevUserIdRef.current = hashedEmail;
                lastIdentifyKeyRef.current = identifyKey;
            } else if (prevUserIdRef.current && !isFetching) {
                // Logout or profile fetch error — reset UserId
                setAmplitudeUserId(undefined);
                prevUserIdRef.current = null;
                lastIdentifyKeyRef.current = null;
            }
        };

        void syncAmplitudeUser();

        return () => {
            cancelled = true;
        };
    }, [email, phone, phoneVerified, picture, isFetching]);

    return null;
};
